import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import React, { Fragment } from 'react';
import { useTheme } from 'styled-components';
import { AppLink } from '@finect/tabular-core/AppLink';
import { getProductTypeLabel, getFundsListPath, getProductTypeByAPISubtype, getManagementCompanyPath } from '@finect/front-resources/Products';
import { Section } from '../../Section';
import { List } from '../../Products';
var FundSameManagementCompanyFunds = function FundSameManagementCompanyFunds(_ref) {
  var fund = _ref.fund,
    funds = _ref.funds,
    subscriptions = _ref.subscriptions,
    onFollow = _ref.onFollow,
    bottomMargin = _ref.bottomMargin,
    _ref$withSPA = _ref.withSPA,
    withSPA = _ref$withSPA === void 0 ? false : _ref$withSPA;
  var theme = useTheme();
  var productType = getProductTypeByAPISubtype(fund.subtype, theme);
  var path = getManagementCompanyPath(theme, productType, fund.managementCompany);
  return React.createElement(Section, {
    bottomMargin: bottomMargin || false,
    title: "Otros ".concat(getProductTypeLabel(productType, 'shortPlural', 'lowercase'), " de ").concat(fund.managementCompany.name),
    subtitle: React.createElement(React.Fragment, null, "M\xE1s ", getProductTypeLabel(productType, 'shortPlural', 'lowercase'), " de", ' ', React.createElement(AppLink, {
      href: path,
      title: "Gestora ".concat(fund.managementCompany.name, " de ").concat(getProductTypeLabel(productType, 'plural', 'lowercase')),
      "data-fi-event": "product-managementCompany"
    }, fund.managementCompany.name), ' ', "ordenados por rentabilidad a 3 a\xF1os."),
    link: {
      text: "Ver ".concat(funds.paging.totalItems, " ").concat(getProductTypeLabel(productType, 'shortPlural', 'lowercase'), " m\xE1s de la gestora ").concat(fund.managementCompany.name),
      href: getFundsListPath(theme, productType, {
        company: fund.managementCompany.id,
        order: '-M36'
      })
    }
  }, React.createElement(List, {
    products: funds.items.slice(0, 15),
    layout: "carousel",
    subscriptions: subscriptions,
    onFollow: onFollow,
    withSPA: withSPA
  }));
};
export default FundSameManagementCompanyFunds;